<template>
  <page :name="$t('Tickets')">
    <template #header>
      {{ $t('Richiedi supporto al team Artera') }}
    </template>

    <pf-page-section>
      <pf-grid gutter>
        <pf-grid-item md="6" xl2="4">
          <pf-card>
            <pf-card-header>
              <pf-title h="3"><book-icon /> {{ $t('Knowledge base') }}</pf-title>
            </pf-card-header>
            <pf-card-body>
              <i18n-t keypath="Ricerca la soluzione al tuo problema nella nostra {0}.">
                <a :href="knowledgeBaseUrl" target="_blank" rel="noopener">{{ $t('knowledge base') }}</a>
              </i18n-t>
            </pf-card-body>
            <pf-card-footer>
              <pf-button variant="link" small :href="knowledgeBaseUrl" target="_blank" icon-position="end">
                <template #icon>
                  <arrow-right-icon />
                </template>
                {{ $t('Vai al knowledge base') }}
              </pf-button>
            </pf-card-footer>
          </pf-card>
        </pf-grid-item>

        <pf-grid-item md="6" xl2="4">
          <pf-card>
            <pf-card-header>
              <pf-title h="3"><ticket-icon /> {{ $t('Ticket') }}</pf-title>
            </pf-card-header>
            <pf-card-body>
              {{ $t('Contatta i nostri tecnici tramite ticket di assistenza') }}
            </pf-card-body>
            <pf-card-footer>
              <pf-button :to="{ name: 'ticket', params: { id: 'new' } }" variant="link" small icon-position="end">
                <template #icon>
                  <arrow-right-icon />
                </template>
                {{ $t('Apri un nuovo ticket') }}
              </pf-button>
            </pf-card-footer>
          </pf-card>
        </pf-grid-item>
      </pf-grid>
    </pf-page-section>

    <pf-page-section>
      <ticket-list :title="$t('Ultimi ticket aperti')" show-if-empty />
    </pf-page-section>
  </page>
</template>

<script lang="ts" setup>
import ArrowRightIcon from '@vue-patternfly/icons/arrow-right-icon';
import BookIcon from '@vue-patternfly/icons/book-icon';
import TicketIcon from '@vue-patternfly/icons/ticket-icon';
import TicketList from '../components/ticket-list.vue';

// URL fuori dal template: vue-tsc 3.3.13 interpreta il // delle URL nelle prop come commento (vuejs/language-tools#6240)
const knowledgeBaseUrl = 'https://kb.artera.net/';
</script>
